export default {
    methods: {
        /**
         * Metodo que determina el ancho maximo del viewport
         * @param {} ref 
         */
        maxWidth(ref) {
            if( ref > 1904 ) {
                return '90vh'
            }
            else if( ref > 1200 ) {
                return '68vh'
            }
        },
        isMobile() {
            if( screen.width <= 768 ) {
                console.log("mobile")
                return true;
            }
            else {
                return false;
            }
        },
        isAdmin(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 1 ){ // 1 Admin
                    sw = true
                    
                }
            })
            return sw
            
        }, 
        isBitacora(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 5){// 5 Bitacora
                    sw = true
                }
            })
            return sw
        },
        isVendedor(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 2){ // 2 Vendedor
                    sw = true
                }
            })
            return sw
        },
        isPreprensa(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 3){ //  3 preprensa
                    sw = true
                }
            })
            return sw
        },
        isIngenieria(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 4){ // 4 Ingenieria
                    sw = true
                }
            })
            return sw
        },
        isRCI(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 6){ //6 RCI 
                    sw = true
                }
            })
            return sw
        },
        //google = programacion

        isGoogle(ref){
            let sw = false
            ref.forEach((value, index)=>{
                if(value.idmenus == 7){ // 7 Google
                    sw = true
                }
            })
            return sw
        },
        isReporte(ref){
            let sw = false
            ref.forEach((value, index)=>{
                if(value.idmenus == 11){ // 11 Reporte
                    sw = true
                }
            })
            return sw
        },
        //nuevo rol tickets  se asigna el identificador 12
        isTickets(ref){
            let sw = false
            ref.forEach((value, index)=>{
                if(value.idmenus == 12){ // 12 Ticket
                    sw = true
                }
            })
            return sw
        },
        isTicketsMantenimiento(ref){
            let sw = false
            ref.forEach((value, index)=>{
                if(value.idmenus == 13){ // 13 TicketMantenimiento
                    sw = true
                }
            })
            return sw
        },
        /**
         * Este metodo verifica si el acceso a bitacora de administrador (todos y todo)
         * @param {*} ref 
         */
        isSapWebAdmin(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 9){ // 9 "SapWebAdmin"
                    sw = true
                }
            })
            return sw
        },
        /**
         * Este metodo verifica si el acceso a bitacora
         * @param {*} ref 
         */
        isSapWebVendedor(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 10 ){ // 10 SapWebVendedor
                    sw = true
                }
            })
            return sw
        },
        isSapWeb(ref){
            let sw = false
            ref.forEach((value, index) => {
                if(value.idmenus == 8){ // 8 SapWeb
                    sw = true
                }
            })
            return sw
        },
        /**
         * Metodo que formatea numeros a miles con la coma (en)
         * @param {*} ref 
         * @returns 
         */
        thousands_separators(ref){
            let num_parts = ref.toString().split(".")
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            return num_parts.join(".")
        },
        twoDecimal: function (value){
            return parseFloat(value).toFixed(2)
          },
        millar: function (value){
            return parseFloat(value).toLocaleString('en') 
        },

        pasarMenuDescripcionaId(ref){
            switch(ref){
                case 'admin': return 1
                    break;
                case 'vendedor' : return 2
                    break;
                case 'preprensa' : return 3
                    break;
                case 'ingenieria' : return 4
                    break;
                case 'bitacora' : return 5
                    break;
                case 'google': return 7
                    break;
                case 'sapweb' : return 8
                    break;
                case 'sapwebvendedor': return 10
                    break;
                case 'sapwebadmin': return 9    
                    break;   
                case 'reporte' : return 11
                    break;
                case 'tickets' : return 12
                    break;  
                case 'ticketsmantenimiento' : return 13
                    break;      
            }
        },
        /**
         * metodo que formatea la fecha la fecha de ---  / / /
         * @param {*} ref 
         * @returns 
         */
        formatoFecha(ref){
            return ref.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');
        },
        
        /**
         * metodo que devuelve un arreglo de los dias en español para uso de calendear
         * @returns 
         */
        shortHandDia(){
     
           return ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
        },
        longHandDia(){
            return ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
        },
        shortHandMes(){
            return ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Оct', 'Nov', 'Dic']
        },
        longHandMes(){
            return ['Enero', 'Febreo', 'Мarzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
        },
        virtualDataFiltered(ref,campo,filtro){
            let result
            
            switch(campo){
                case 'OF':
                      result = ref.filter((item) => {
                          return ( item.OF.toLowerCase().includes(filtro.toLowerCase()) 
                                  )
                                  }) 
                      return result            
                                  
                  break;
                case 'ESTATUS_OF':
                      result = ref.filter((item) => {
                        return ( item.ESTATUS_OF.toLowerCase().includes(filtro.toLowerCase()) 
                        )
                      }) 
                      return result
                      break  ;
                case 'Cliente':
                      result = ref.filter((item) => {
                      return ( item.Cliente.toLowerCase().includes(filtro.toLowerCase()) 
                      )
                    })
                    return result
                    break;
                case 'Descripcion':
                      result = ref.filter((item) => {
                      return ( item.Descripcion.toLowerCase().includes(filtro.toLowerCase()) 
                      )
                    })
                    return result
                    break;
                case 'NAI':
                      result = ref.filter((item) => {
                      return ( item.NAI.toLowerCase().includes(filtro.toLowerCase()) 
                      )
                    })
                    return result
                    break;
                case 'NASN':
                      result = ref.filter((item) => {
                      return ( item.NASN.toLowerCase().includes(filtro.toLowerCase()) 
                      )
                    })
                    return result
                    break;
                default:
                      return ref
            }
        },
        nombreMaquina(ref){
            switch(ref){
                case 'BitacoraCD74':
                    return 'CD74'
                    break;
                case 'Guillotina':
                    return 'Guillotina'
                    break;
                case 'Bobst106':
                    return 'TroqN106'
                    break;
                case 'BitTroqueladora3':
                    return 'Troq Heidelberg'
                    break;
                case 'BitTroqueladoraN1':
                    return 'Troq N1'
                    break;
                case 'BitPegadora':
                    return 'Pegadora'
                    break;
                case 'CierreOrdenFabricacion':
                    return 'Cierre Of'        
                    break;            

            }

        },
        stringToDate(_date,_format,_delimiter)
        {
            let formatLowerCase=_format.toLowerCase();
            let formatItems=formatLowerCase.split(_delimiter);
            let dateItems=_date.split(_delimiter);
            let monthIndex=formatItems.indexOf("mm");
            let dayIndex=formatItems.indexOf("dd");
            let yearIndex=formatItems.indexOf("yyyy");
            let month=parseInt(dateItems[monthIndex]);
            month-=1;
            let formatedDate = new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
            return formatedDate;
        },
        selectText(ref){
            return ref.target.options[ref.target.options.selectedIndex].text
        },
        filtroTitulo(ref,filtro){
            let result = []
            
            filtro.forEach((val) => {
                ref.forEach((item) => {
                 
                 if (item.titulo.toLowerCase() === val.nombre.toLowerCase() )
                    result.push(item)
            })
            })//this.filtro.forEach
            return result
        },
        filtroEstado(ref,filtro){
            let result = []
            filtro.forEach((val) => {
                ref.forEach((item) => {   
                 if (item.estatus.toLowerCase() === val.nombre.toLowerCase() )
                    result.push(item)
                })
            })//this.filtro.forEach
            return result
        },
    }
}